import { render, staticRenderFns } from "./ListEarlyLearningYearsFramework.vue?vue&type=template&id=6bf5d09f&"
import script from "./ListEarlyLearningYearsFramework.vue?vue&type=script&lang=js&"
export * from "./ListEarlyLearningYearsFramework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports